export const imgUrl="https://do-dora.oss-cn-chengdu.aliyuncs.com/"//图片地址
export const httpUrl="https://chainapitest.milibox.cn/"
export const bucket="do-dora"

//正式服
//  export const imgUrl="https://do-dora-formal.oss-cn-chengdu.aliyuncs.com/"//图片地址
//  export const httpUrl="https://chainapi.milibox.cn/" //服务器地址
//  export const bucket="do-dora-formal"
